import { Controller } from '@hotwired/stimulus';

// Interactive 1-5 star picker for the account review form.
// Paint filled/empty icons from the submitted rating input.
export default class extends Controller {
  static targets = ['input', 'star'];

  connect() {
    this.paint();
  }

  select({ params: { value } }) {
    this.inputTarget.value = value;
    this.paint();
  }

  paint() {
    const rating = Number(this.inputTarget.value);
    this.starTargets.forEach((el) => {
      const star = Number(el.dataset.reviewRatingValueParam);
      const filled = star <= rating;
      el.querySelector('[data-on]').classList.toggle('d-none', !filled);
      el.querySelector('[data-off]').classList.toggle('d-none', filled);
      el.setAttribute('aria-checked', star === rating ? 'true' : 'false');
    });
  }
}
